//zh.js
export default {
    home:{
      introduce:'歌力思集团作为多品牌时尚集团，成立至今旗下汇聚中国高端时装品牌ELLASSAY、德国高端女装品牌Laurèl、法国设计师品牌IRO、英国当代时尚品牌self-portrait和加拿大高端功能性羽绒品牌nobis。',
      btnTxt:"点击探索 ELLASSAY GROUP"
    },
    nav: {
      home: '首页',
      group:'集团',
      profile:'集团简介',
      brands:'旗下品牌',
      sustainability:'可持续时尚',
      work:'在歌力思工作',
      // finance:'投资者关系',
      discover:'探索',
      investors:'投资者关系',
      historyTxt:'集团发展史',
      financial:'公告',
      external:'友情链接'
    },
    footer:{
      follow:'关注我们',
      group:'歌力思集团',
      supporter:'特别支持',
      investors:'中国投资者网',
      legal:'法律声明',
      customization:'团体定制'
    },
    brandClassify:{
      ambassador:'#ELLASSAY虚拟数字人@飒ELISA',
      talents:'人才 '
    },
    groupIntroduce:{
      profile:'歌力思集团',
      content1:'歌力思集团作为多品牌时尚集团，自成立以来一直专注于高端时装品牌的发展运营。2015年4月22日，歌力思（SH.603808）正式在上海证券交易所主板上市，如今旗下已汇聚中国高端时装品牌ELLASSAY、德国高端女装品牌Laurèl、法国设计师品牌IRO、英国当代时尚品牌self-portrait和加拿大高端功能性羽绒品牌nobis。',
      content2:'现已形成集时尚、潮牌、轻奢、网红等多领域的国际化品牌矩阵，覆盖不同细分市场需求。',
      p1:'歌力思集团的多品牌策略，要求旗下每一个品牌都拥有自己清晰的市场定位和价值主张，每个品牌都有独立的设计、运营、推广和销售团队，以此确保品牌的独特性与灵活性。',
      p2:'集团在致力于“成为有国际竞争力的高端时装品牌集团”的目标下，不断汇聚、协调共享资源，激发品牌的创造力，提供能助力品牌实现卓越的一切条件，使旗下每一个品牌都能拥有长远的发展。',
      p3:'歌力思集团始终重视数字化赋能，依托参股企业百秋网络积极进行新零售领域的探索，实现了品牌线上能力的完善；同时依托子公司野兽数字科技加速数字化运营，以全域品牌+全渠道营销快速打通线上线下。',
      goalTitle:'集团目标',
      goalTxt:'“成为有国际竞争力的高端时装品牌集团”',
      missionTitle:'集团使命',
      missionTxt:'“用时尚创造个性魅力”',
      visionTitle:'集团愿景',
      visionTxt:'“拥有千位事业合伙人的共创共享平台”',
      bossName:'夏国新',
      bossSub:'歌力思集团创始人兼董事长',
      t1:'夏国新，ELLASSAY歌力思品牌创始人，深圳歌力思服饰股份有限公司董事长，中国服装设计师协会主席。曾获“深圳经济特区30年行业领军人物”、“2012年中国纺织年度创新人物”、“2019年深圳商业40年十大功勋人物”等荣誉称号及奖项。',
      t2:'1993年，夏国新先生从天津纺织工学院服装硕士毕业后，主动申请到深圳并开始创业，1996年创立自己的品牌，取名“ELLASSAY歌力思”。2015年4月22日，在夏国新先生的带领下公司正式在上海证券交易所挂牌上市（股票简称“歌力思”，股票代码“603808”），同时也使得ELLASSAY歌力思成为首个在证券交易所进行时装大秀的品牌。',
      t3:'上市后，夏国新先生带领集团不断进行全球优质品牌资源的并购整合，使歌力思集团成为中国最大的多品牌时尚集团之一。他希望打造一个“有国际竞争力的高端时装品牌集团”，这个目标是歌力思集团发展的核心，并不断推动集团延伸和扩大国内、国际的影响力，带来真正属于中国创造的国际时尚。'
    },
    historyInfo:{
      historyTxt:'歌力思集团发展史',
      p1:'集团旗下主品牌ELLASSAY歌力思第一家品牌专卖店开业。由于服装品质卓越，版型优美，很快获得市场青睐，成为代表中国女性优雅气质的时装品牌典范之一。',
      p2:'YSL圣罗兰12年产品研发总监、国际顶级服装大师JEAN PAUL KNOTT受聘成为ELLASSAY歌力思品牌设计顾问，其独特简约的风格和极具前瞻性的创意，让品牌影响力迅速提升。',
      p3:'ELLASSAY歌力思品牌开辟WEEKEND产品线，并于CHIC开幕大秀“光影 | 城市”上正式发布。',
      p4:'代表女性优雅、卓越与高贵气质的FIRST产品线问世。',
      p5:'9月在纽约Lincoln Center时装周主会场举行 The City Light 2014春夏高级时装秀。自此从2014年到2019年，ELLASSAY歌力思品牌每季受邀国际时装周（纽约、米兰）发布新季时装。',
      p6:'4月22日深圳歌力思服饰股份有限公司正式在上海证券交易所挂牌上市，成为2015年A股上海主板第一家女装上市企业，股票代码SH.603808。',
      p7:'集团收购德国高端女装Laurèl，拥有Laurèl在中国大陆地区独立设计权和生产权。',
      p8:'集团收购美国轻奢潮流品牌Ed Hardy。',
      p9:'进行全球控股收购法国设计师品牌IRO。',
      p10:'11月2日在北京太庙正殿，集团旗下ELLASSAY、Laurèl、Ed Hardy、IRO四个品牌集体亮相，展现各品牌新一季时装作品，引起轰动。',
      p11:'集团与英国当代时尚品牌self-portrait成立合资公司，实现self-portrait在中国大陆的经营和管理。',
      p12:'集团与腾讯智慧零售实现战略合作，全面开启数字化转型。',
      p13:'ELLASSAY歌力思品牌启动虚拟数字人@飒ELISA的打造，布局数字时尚赛道。',
      p14:'集团授予Dominique Simard先生 “集团首席可持续时尚官”称号，负责制定集团可持续发展战略及指导集团各品牌可持续事务的实践，并将冠名基金正式更名为“深圳市慈善会 · 歌力思可持续时尚基金”，开启可持续时尚新纪元。',
      p15:'集团通过合资经营公司取得加拿大高端功能性羽绒品牌nobis在中国大陆和香港、澳门地区的所有权。'
    },
    EsubBrand:{
      // dateTxt:'诞生于1996',
      // p1:'ELLASSAY歌力思从1996年创立至今，凭借独具特色的品牌经典和不断的探索革新，彰显品牌创意精神，创造出优雅与率性兼具的品牌风范。',
      // p2:'品牌始终延续优雅并充满女性魅力的形象，不仅创造了珍贵的品牌发展历史，更使品牌保持着独特的创新精神。',
      // p3:'如今，ELLASSAY歌力思正致力于与年轻一代消费者建立起情感链接，用新颖视角为品牌DNA注入自由率性和趣味性。从虚拟数字人@飒ELISA的推出，到演员童瑶出任品牌代言人；从WEEKEND产品线焕新，到沉浸式光感球幕秀场的打造，ELLASSAY歌力思正以极具未来感的先锋创意开启品牌新篇章。',
      dateTxt:'歌力思 ELLASSAY：为优雅而生，为光而存在。',
      p1:'生于国际视野，成于东方诗性。1996年的深圳，夏国新先生在中国的时尚土壤埋下的“优雅”种子孕育而生，它注定不凡的名字是——ELLASSAY。源自法语的"Elle"（她）与英语的"Say"（表达），它以国际化的表达，织就中国女性之美。',
      p2:"创始人夏国新先生的坚持，源于一个简单的信念：真正的美，应当经得起时间的凝视。而这种能承载自我、表达态度的现代优雅美学，不是源于外界的标准，而是女性内在秩序的投射。",
      p3:"优雅不是标签，而是一种选择。它属于那些在快节奏中依然保持自我节律的女性，属于那些在多重身份间游刃有余，却始终温柔有力的灵魂。“简而不凡，光而不耀”，这既是歌力思的设计哲学，也是创始人夏国新对中国女性最深刻的理解。",
      p31:"夏国新先生始终相信：真正的优雅，从不依附于时代，它只忠于自我。歌力思优雅相伴你的每个高光时刻。",
      personName:'Jean Paul Knott',
      personTit:'首席设计顾问',
      p4:'Jean Paul Knott于1988年从纽约著名的服装学府FIT毕业，加入法国YVES SAINT LAURENT（圣罗兰）任职12年产品研发总监，曾多次在巴黎卢浮宫发布个人产品。',
      p5:'2004年，ELLASSAY歌力思聘请Jean Paul Knott先生担任品牌首席设计顾问并一直合作至今。',
      fashionShow:'品牌发布会',
      btnTxt1:'探索',
      campaign:'品牌广告大片',
      ambassador:'歌力思品牌代言人   童瑶',
      btnTxt2:'探索更多明星好友',
      storeTxt:'门店形象',
      follow:'关注',
      others:'探索其他品牌',
      describeTxt:'ELLASSAY歌力思在全国拥有近300家终端门店，遍布全国170+城市核心商圈',
      d1:'北京SKP / 上海八佰伴',
      d2:'广州天河城 / 广州隆德专卖店',
      d3:'深圳金光华广场 / 深圳宝安壹方城 / 深圳华润万象城',
      d4:'杭州银泰武林店 / 南京德基店',
      d5:'成都王府井 / 厦门万象城 / 沈阳万象城 / 青岛海信 / 武汉广场 / 长沙国金'
    },
    LsubBrand:{
      p1:'Laurèl，1978年创建于德国慕尼黑，主张将实用艺术注入现代生活，运用立体考究的剪裁，舒适精致的面料，以简约、艺术、现代的风格，诠释出都市女性独立、智慧的现代形象。',
      personTit:'品牌创始人夫妇',
      p2:'Wolfgang & Margaretha Ley 夫妇将包豪斯的精确设计哲学和德式工匠精神融入Laurèl的服饰，强调女性的力量和情感，并试图让穿着者从皮肤开始感受令人印象深刻的设计并爱上时装。同时，"SEE·FEEL·LOVE" 开始成为Laurèl的品牌主张。',
      follow:'关注',
      describeTxt:'Laurèl劳芮在中国拥有近100家终端门店，遍布全国70+城市核心商圈',
      d1:'北京SKP/上海IFC/成都SKP/香港IFC',
      d2:'深圳湾万象城/深圳华润万象城/深圳前海壹方城/深圳龙华壹方城/深圳金光华广场/深圳KKMALL',
      d3:'沈阳万象城/太原万象城/青岛万象城/武汉万象城/南昌万象城/杭州万象城/宁波万象城/海口万象城',
      d4:'长春欧亚商都/哈尔滨远大/大连麦凯乐/济南银座/西安SKP/郑州大卫城/武汉国广/南京德基广场/贵阳国贸广场/昆明恒隆广场',
    },
    EDsubBrand:{
      p1:'美国轻奢潮流品牌Ed Hardy于2004年正式成立，品牌以Don Ed Hardy先生名字命名，将纹身艺术引入时尚领域，注入了复古朋克元素及街头文化。“定义自我，携刻信仰” 是品牌基因。',
      personTit:'品牌创始人',
      p2:'Don Ed Hardy先生儿时起便对纹身产生浓厚兴趣，觉得纹身是件很酷的事情。大学毕业于旧金山艺术学院，拒绝了耶鲁大学研究生奖学金的他开始走上了纹身的职业道路。他花费毕生精力将街头文化、东洋艺术、纹身艺术、改装机车、冲浪文化和符号学融为一体，被业界尊称为“当代纹身教父”。',
      follow:'关注',
      describeTxt:'截止2022年Ed Hardy 已于上海、北京、深圳、广州、厦门、哈尔滨等各大城市开设110家实体店',
      d1:'北京新光天地/上海嘉里中心',
      d2:'西安赛格/杭州大厦/武汉国际广场购物中心/哈尔滨远大购物中心/长沙IFS购物中心',
    },
    IROsubBrand:{
      p1:'诞生于2005年的IRO，经由法国Bitton设计师兄弟于纽约和巴黎同时启动。品牌将法式浪漫与美式摇滚巧妙融合，主张每个女孩做真实的自己。',
      personTit:'品牌创始人兄弟',
      p2:'Arik Bitton与Laurent Bitton兄弟由摇滚乐起家，被同样的愿望驱动，他们建立了一个摩登而强大的衣橱，为都市摩登女孩提供时髦的、个性的、独特的成衣设计。“只做自己人生的主角，从不盲目追随潮流”，Bitton兄弟主张每个女孩做真实的自己，日常的单品就可以激发出缪斯的酷女孩形象。',
      follow:'关注',
      p3:'我希望赋予每一个普通人一个有趣的故事。',
      describeTxt:'目前，IRO已覆盖全球30多个国家，开设70余家门店，超过600家营业点',
    },
    SPsubBrand:{
      p1:'self-portrait是一个独立的、富有个人风采、且以消费者为中心的英国当代时尚品牌。由毕业于伦敦中央圣马丁的马来西亚华裔设计师HAN CHONG于2013年成立，并迅速建立了令人羡慕的声誉。',
      personTit:'品牌创始人兼创意总监',
      p2:'英国当代时尚设计师，毕业于伦敦中央圣马丁学院。在成为时装设计师之前，HAN首先进入的是艺术领域，他的作品曾进入2011年威尼斯双年展（Venice Bien-nale）。因为这个“非常规式 ”的起点，HAN会优先从艺术的角度考量时装设计，像呈现艺术品一样去设计每一件时装。',
      follow:'关注',
      p3:'2013年，HAN在伦敦创立了self-portrait品牌，因其精细的做工和独具设计感的剪裁，迅速建立了令人羡慕的声誉。品牌至今已覆盖70多个国家及地区，拥有300多个销售网点，成为全球明星博主钟爱的时尚品牌。',//无翻译
      d1:'',
      s1:'伦敦梅菲尔区W1S 4JR 阿尔伯马尔街49号/',
      d2:'曼谷',
      s2:'中央大使馆2F',
      d3:'北京',
      s31:'太古里南区一层S8-12/',
      s32:'建国路SKP商场负一层B1003/',
      s33:'王府中环东座三层',
      d4:'上海',
      s41:'静安区芮欧百货310/',
      s42:'IFC国际金融中心LG1-63',
      d5:'成都',
      s5:'远洋太古里东里一层1328号/',
      d6:'南京',
      s6:'玄武区德基广场一期三层/',
      d7:'西安',
      s7:'SKP负一层UA1002号/',
      d8:'沈阳',
      s8:'万象城三层378/',
      d9:'香港',
      s9:'国际金融中心商场一层1053B/',
      d10:'台北',
      s10:'微风信义三层68号',
      sz:'深圳',
      sz1:'万象城三层395号/',
      sz2:'COCO Park一期一层L1-065/',
      sz3:'万象天地负一层LG23',
    },
    nobissubBrand:{
      title:'nobis',
      a1:'nobis，在拉丁语中是「我们」的意思，品牌创立于2007年。作为全球知名的加拿大高端功能性羽绒品牌，nobis坚信风格、功能和质量会保持永恒。品牌系列为全球不断变化的冬季、不可预测的季节状况，以及对时尚和功能性服装日益增长的需求而设计。',
      name:'Robin J. Yates',
      subName:'品牌联合创始人',
      b1:'奢侈品外衣领域真正的创新者，Robin 曾担任Canada Goose的副总裁超过10年。在户外环境中长大的他看来，户外是一种自由，甚至是一种灵性。',
      b2:"“nobis从创立之初就强调了其具有很强适应性的能力。我们将内置的性能属性融入到外衣设计中，让它不仅仅是一件时尚单品，也不仅仅是一件专业的户外单品。我们是真的把这两个结合了起来。”—— Robin J. Yates",
      storeTxt:'门店形象',
      describeTxt:'目前，nobis在北美、欧洲和亚洲，包括美国、英国、德国、瑞典、挪威、芬兰、丹麦、捷克共和国、奥地利、日本和韩国，以及nobis发源地加拿大等35个国家拥有销售网点。',
      describeTxt1:''
    },
    susFashion:{
      p1:'在歌力思集团，我们相信未来时尚行业的运作方式将会发生很大改变。',
      p2:'一直以来，时尚业对地球上的气候、海洋、生物等环境产生的影响是令人震惊的，全球范围内的资源消耗引起了各大产业的共同关注，各行各业相继开启可持续转型。与此同时，越来越多的消费群体也在主动寻求可持续产品，与环保品牌产生互动与关联。',
      p3:'在全世界对可持续发展热情高涨的当下，歌力思集团决定成为积极参与这一转变的公司之一，在产业变革中发挥建设性作用，共促负责任消费，为建立一个更加美好的世界承担起我们应有的社会与环境责任。',
      // sTitle:'减少碳排放的承诺',
      // s1:'气候变化给地球环境带来了严峻的挑战，歌力思集团决定在保护气候方面做出关键性贡献。为了减缓气候问题，确保人类未来可以拥有更好的生活质量，我们开启了一系列科学措施以检测企业碳排放，并制定了从供应链到自身运营，全方位的节能减排计划。',
      // s2:'集团将从2022年起不断导入节能型生产商，在2025年前实现供应链向低碳节能方向的迭代升级；',
      // s3:'为了准确了解我们的碳排放，有针对性地优化价值链，集团已加入由中国纺织工业联合会CNTAC启动的“30·60碳中和加速计划”，并加入CNTAC-LCA工作组，测量特定产品生命周期碳足迹，首次检测报告将于2022年初完成。',
      sTitle:'减少对气候影响的承诺',
      s1:"气候变化给地球环境带来了严峻的挑战，歌力思集团决定在保护气候方面做出关键性贡献。为了减缓气候问题，确保人类未来可以拥有更好的生活质量，我们开启了一系列科学措施以检测企业碳排放，并制定了从供应链到自身运营，全方位的节能减排计划。",
      s2:"集团从2022年起开始不断导入节能型生产商，并在可持续发展上与主要供应商开启定期的研讨和培训，不断让利益相关者参与进来。2025年，集团将实现供应链向低碳节能方向的迭代升级。",
      s3:'为了准确了解我们的碳排放，集团计划在2027年完成从原材料到零售环境的一系列科学检测。2023年我们将完成范围1和范围2的碳排放计算，并制定节能减排计划。到2027年，集团可以在所有品牌中宣布范围3排放的测量，并完善减碳方案。',
      s4:'集团已加入由中国纺织工业联合会CNTAC启动的“30·60碳中和加速计划”，并加入CNTAC-LCA工作组，测量产品生命周期碳足迹。到2023年，ELLASSAY歌力思与德国Laurèl品牌已与CNTAC积极开展产品碳足迹溯源，集团将继续鼓励旗下其他品牌加入产品碳检测计划并向消费者公示。',
      gTitle:'循环经济的承诺',
      g1:'歌力思集团相信循环经济将会很好地适用于时尚行业并发挥巨大的积极作用。为了向循环经济转型，歌力思集团正在倡导旗下品牌从设计端开始考虑产品的可持续性，特别是可循环性，即考虑到产品生命周期结束后的下一个潜在用途。',
      // g2:'从2022春夏系列开始，ELLASSAY及Laurèl品牌已经开始梳理各自可持续产品占比，并预计到2025年分别达成20%和30%的可持续产品目标占比。未来，品牌将不断增加再生面料的投入。同时，集团也将不断开发、汇聚更多优质的可持续面料制造商，与之建立合作关系，让旗下品牌共享；',
      // g3:'集团计划在3年内实现95%的2C以及2B可持续产品包装；',
      // g4:'建立「可持续面料创新实验室」，推动再生织物与纺织品及其他可持续材质的开发，为集团品牌提供更多创意解决方法，特别是在产品的设计研发中，能够拥有更多可持续的选择。创新实验室将与国内高等院校联合成立，鼓励在校学生发挥创造力，培养新一代人才对可持续时尚的热情。',
      // g2:"从2022春夏系列起，ELLASSAY歌力思及德国Laurèl品牌开始致力于提高每季可持续产品占比。2022秋冬系列两个品牌的可持续产品SKU占比为12%，到2023春夏，这一比例提升至15%-18%。2025年，ELLASSAY歌力思、德国Laurèl、美国Ed Hardy以及法国IRO品牌的可持续产品将达到25%。",
      g2:"从2022春夏系列起，ELLASSAY歌力思及德国Laurèl品牌开始致力于提高每季可持续产品占比。2022秋冬系列两个品牌的可持续产品SKU占比为12%，到2023春夏，这一比例提升至15%-18%。2025年，ELLASSAY歌力思、德国Laurèl、法国IRO品牌的可持续产品将达到25%。",
      g3:"集团旗下ELLASSAY歌力思、德国Laurèl品牌购物纸袋100%采用FSC认证纸张，法国IRO及英国self-portrait品牌包装纸盒也都采用了100%再生纸张作为原料。到2025年，集团计划实现所有品牌95%的FSC认证可回收包装，并消除塑料的使用。到2030年实现100%的B2B塑料袋可持续解决方案。",
      g4:"建立「可持续面料创新实验室」，推动再生织物与纺织品及其他可持续材质的开发，为集团品牌提供更多创意解决方法，特别是在产品的设计研发中，能够拥有更多可持续的选择。创新实验室将与国内高等院校联合成立，鼓励在校学生发挥创造力，培养新一代人才对可持续时尚的热情。",
      // dTitle:'保护生物多样性',
      // d1:'2021年，集团正式加入由全球70余家时尚及纺织品企业首席执行官领导的可持续联盟——《The Fashion Pact 时尚公约》，与世界各地的时尚集团及品牌（如Kering、CHANEL、Burberry、HERMES等）分享可持续时尚的经验和行业资源。《时尚公约》的聚焦点是气候问题，保护海洋和保护生物多样性。因此，集团在2022年开始关注「保护生物多样性」这个新的议题。',
      // d2:'歌力思集团已与阿拉善种树植心生态文明实践教育中心开启合作，认种抚育1100亩沙生灌木林，并命名为「歌力思林」。沙生绿植由于其耐旱、喜光、适应性强的特点，在阻止沙漠对生态空间的侵蚀上发挥着至关重要的作用。同时，构筑沙漠锁边生态绿洲也有利于生物多样性的保护、恢复和再生。',
      // d3:'2023年，歌力思集团成为首批与Canopy及其CanopyStyle、Pack4Good项目合作的中国时尚品牌，共同致力于保护全球濒危森林，关注集团旗下品牌再生纤维面料和纸质包装。这一崭新的合作与歌力思集团保护生物多样性的倡议完美契合，且有助于减少我们对自然的影响。',
      aLink:'查看更多',
      dTitle:'恢复生物多样性的承诺',
      d1:"作为The Fashion Pact 《时尚公约》的成员，歌力思集团始终与世界各地的时尚集团及品牌（包括Kering开云、CHANEL、Burberry、HERMÈS等）同行，分享可持续时尚的经验和行业资源。《时尚公约》聚焦气候问题，保护海洋和生物多样性。因此，集团在2022年开始关注「恢复生物多样性」这个新的议题。",
      d2:'歌力思集团持续投身生态修复与自然栖息地保护，携手阿拉善种树植心生态文明实践教育中心，认种抚育1200亩沙生灌木林，并命名为「歌力思林」。沙生绿植在阻止沙漠对生态空间的侵蚀上发挥着至关重要的作用。同时，构筑沙漠边生态绿洲也有利于生物多样性的保护、恢复和再生。',
      d3:"2023年，歌力思集团成为首批与Canopy及其CanopyStyle、Pack4Good项目合作的中国时尚品牌，共同致力于保护全球濒危森林，通过森林友好型包装与环保粘胶纤维，积极推动「零毁林」的实现，助力恢复生物多样性。",
      // d4:"目前，歌力思集团旗下主品牌 ELLASSAY歌力思、德国Laurèl、美国Ed Hardy 、法国IRO和加拿大nobis门店购物袋已100%采用FSC认证纸张或再生纸。到2030年，集团计划实现100%的B2B塑料袋可持续解决方案。",
      d4:"目前，歌力思集团旗下主品牌 ELLASSAY歌力思、德国Laurèl、法国IRO和加拿大nobis门店购物袋已100%采用FSC认证纸张或再生纸。到2030年，集团计划实现100%的B2B塑料袋可持续解决方案。",
      yTitle:'深圳市慈善会·歌力思可持续时尚基金',
      y1:'ELLASSAY歌力思2011年成立艺术公益基金，成立以来一直致力于发展艺术公益事业，开展各领域的文化艺术交流与慈善活动。2021年，歌力思艺术公益基金正式更名为“深圳市慈善会·歌力思可持续时尚基金”，未来致力于可持续时尚公益事业，加强可持续时尚资源整合与行业整体合作。',
      y2:'基金捐赠项目',
      y3:'歌力思可持续时尚基金 x 上海真爱梦想基金',
      y4:'自2012年合作至今，歌力思可持续时尚基金与上海真爱梦想基金已合作11年，在13个省累计捐建25间梦想中心，帮助31674位孩子享受到优质的素养教育课程。',
      y5:'歌力思可持续时尚基金 x “免费午餐” 公益基金',
      y6:'2014年至2015年，歌力思可持续时尚基金与“免费午餐”公益基金合作，为国内贫困学童募集到27000余份“免费午餐”。',
      y7:"歌力思可持续时尚基金 x 深圳大学 / 北京服装学院 / 武汉纺织大学",
      y8:'自2013年起，歌力思可持续时尚基金已在深圳大学、北京服装学院、武汉纺织大学多个高校设立公益善款，用于支持高校人才培养，赞助优秀毕业设计作品。',
      y9:'歌力思可持续时尚基金 x 中国SOS儿童村协会',
      y10:'自2019年合作至今，歌力思可持续时尚基金每年携手中国SOS儿童村，共同推出公益跨界联名T恤，努力让人们一同关注失去家庭关爱的孤儿群体。',
      y11:'歌力思可持续时尚基金 x 阿拉善“种树植心”',
      y12:'2020年至2021年，公司通过基金在阿拉善腾格里沙漠锁边生态公益基地累计认种抚育1100亩沙生灌木林，以支持生态林及生态教育建设，同时也有助于生物多样性的保护、恢复和再生。',
      person1:'集团首席可持续时尚官',
      x1:'Dominique Simard自2003年成为上海时尚设计教育领域的领军人物，培养了数百名的行业专业人士与设计师。曾担任康泰纳仕时尚与设计学院（Condé Nast Center of Fashion & Design）执行董事、IFA Paris的市场营销及业务发展总监等，与多个国际一线品牌有过项目合作及培训经历。',
      x2:'2021年，歌力思集团正式授予Dominique Simard先生「集团首席可持续时尚官」称号，负责制定集团可持续发展战略及指导集团各品牌可持续事务的实践。时常被行业提及的改变，在Dominique先生的带领下启程。',
      person2:'虚拟数字人@飒ELISA',
      z1:'集团可持续时尚大使',
      z2:'2022年3月，@飒ELISA进入歌力思集团可持续发展部，成为集团首位数字员工，并担任「集团可持续时尚大使」一职，开启可持续时尚在虚拟世界的探索与创想。',
      z3:'虚拟数字人入职所带来的科技赋能和多元文化碰撞，对歌力思集团的未来至关重要。@飒ELISA自带的数字化和未来感属性也将和集团形成优势互补，为可持续决策提供更多新视角。',
      person3:"陈碧舸Bonnie",
      f1:'集团可持续时尚大使',
      f2:'2023年歌力思集团官宣超模陈碧舸担任歌力思集团可持续时尚大使。',
      f3:'“歌力思是我很多年的好朋友，这是很棒的缘分，我非常非常感谢歌力思能够为我们提供这样有意义的机会。我觉得可持续不仅在时尚品牌中，它与我们每个人的未来人生都息息相关，环境改变已经让我们每个人都意识到环保的重要性，我们终于可以一起为时尚行业做点什么了。”',
      f4:'—— 陈碧舸',
      reportTitle:"环境、社会及公司治理（ESG）报告",
      reportSub:"歌力思集团每年定期发布《环境、社会及公司治理（ESG）年度报告》，展示可持续发展和社会责任上取得的进展及成果。",
      report4:"2024年度",
      report3:"2023年度",
      report2:"2022年度",
      report1:"2021年度",
      reportTxt:"环境、社会及公司治理（ESG）报告"
    },
    personalTailor:{
      title:'ELLASSAY 歌力思团体定制',
      subT:'歌力思行政职业装',
      aTitle:'高端时尚职业装的引领者',
      ap1:'为充分满足细分客户的需求，歌力思成立了职业装团体定制中心，面向各企事业单位提供一站式职业装定制解决方案，定制产品涵盖男女士职业正装、商务休闲装的全品类。依托集团强大的设计研发优势与资源整合能力，歌力思打破传统的桎梏，将国际化、时尚化的理念注入职业装，推陈出新，致力于做高端时尚职业装的引领者。20余年品牌沉淀，口碑相传，由歌力思提供职业装定制服务的企事业单位遍及金融、能源、通信、交通、政府、学校等各行业。',
      ap2:'',
      bTtitle1:'国际知名设计师操刀',
      bTtitle2:'高端时尚浑然天成',
      bp1:'由曾任职法国YSL品牌成衣设计总监12年的Jean Paul Knott担任首席设计顾问，带领集团顶尖的设计团队，以国际化的视野与审美融合东方人的形体特征，打造更适合中国人的版型，将高端、时尚的理念融入歌力思职业装，精良的版型造就浑然天成的高级感。',
      cTtitle1:'',
      cTtitle2:'',
      cp1:'',
      dTtitle1:'携手顶级面料世家',
      dTtitle2:'上乘材质尽显精英风雅',
      dp1:'歌力思与享誉世界的顶级面料供应商如Zegna、Cerruti1881、REDA、VBC等保有稳定合作关系，持续升级面料研发，将舒适、健康与科技渗透其中，上乘材质带来卓越的质感，尽显精英气质与优雅品味。',
      eTtitle1:'精益制造工艺',
      eTtitle2:'数字化把控生产线',
      ep1:'集团拥有5.9万平方米的现代化时尚产业园，数百台进口的先进服装机械设备，800余名熟练的工人，数字化把控生产流水线，对服装制造的360道工序层层把关，确保高效率的生产，充分满足企业的批量定制与个性化需求。',
      fTtitle1:'做企业的形象顾问',
      fTtitle2:'专业团队提供全方位服务',
      fp1:'歌力思团体定制服务团队立志于做企业的专业形象顾问，为企业塑造富于内涵品位的新形象，助推提升企业的竞争力。团队配备了完善的服务体系，从设计、量体、制版、生产、配送到售后，全流程匹配精准的服务，提供一站式职业装团体定制解决方案。',
      serve:'服务客户'
    },
    release:{
      title:'ELLASSAY品牌发布会',
      a1:'HELLO ELLASSAY',
      a2:'2022春夏深圳时装周',
      b1:'Into The Blu 海洋传说',
      b2:'2020春夏米兰时装周',
      c1:'GIARDINO MAGICO',
      c2:'2019春夏米兰时装周',
      d1:'IN THE FUTURE',
      d2:'2018春夏米兰时装周',
      e1:'VIAGGIO D’ARTE 艺术之旅',
      e2:'2017春夏米兰时装周',
      f1:'ELLASSAY歌力思优雅20周年盛典',
      f2:'北京太庙正殿时装秀',
      g1:'THE GRACEFUL ARTIST',
      g2:"2015春夏纽约时装周",
      h1:'THE CITY LIGHT',
      h2:'2014春夏纽约时装周',
      i1:"新经典 The Blooming Classics",
      i2:"2024秋冬巴黎时装周",
    },
    releaseVideo:{
      p1:'ELLASSAY WEEKEND 2022春夏发布会携手深圳时装周，打破物理局限，进一步开启对时尚元宇宙的探索。以国际前沿技术的跨界运用，多维度光感秀场的视觉加持，开启ELLASSAY WEEKEND系列的全新篇章。',
      p2:'米兰时间9月22日上午，ELLASSAY歌力思第四次受邀参加米兰时装周，将2020春夏新季秀场置于世界著名的绅士俱乐部SOCIETÀ DEL GIARDINO宫殿。在这座许多国际历史重要人物、国王、总理、政治家、科学家和艺术家都曾留下足迹的宫殿中，ELLASSAY新季时装与音乐风格徘徊于现代的高级时装语言与的神秘恬静的海洋韵律之间，呈献2020春夏“INTO THE BLU海洋传说”的浪漫意境。',
      p3:'米兰时间2018年9月22日，ELLASSAY歌力思受米兰时装周官方邀约，在意大利18世纪新古典主义建筑为代表的百年宫殿PALAZZO BOVARA（博瓦拉宫）发布新季主题为“GIARDINO MAGICO”的2019春夏高级时装。新季不去大谈未来，也无心回溯典雅，更想抓住当下的也是永恒的自然之美，带领现代女性回归花园秘境与内心深处。',
      p4:'米兰时间2017年9月25日，ELLASSAY歌力思应米兰时装周主办方邀请，在举世闻名的米兰18世纪古建筑PALAZZO CLERICI（克莱里奇宫殿）发布2018春夏新季时装“IN THE FUTURE”。在未来主义、科技感等关键词的预热下，ELLASSAY脱颖而出引领未来科技时装风潮，以视觉语言传递时尚态度，率先在行业中践行FASHION×TECHNOLOGY的创新理念，提出时尚科技的“适度”理论——让女性更加自然与舒适的体验科技感时装，让科技更好地为时尚服务。',
      p5:'ELLASSAY歌力思首秀米兰时装周，以中国优雅探寻米兰艺术之旅。2016年9月26日，ELLASSAY应米兰时装周官方邀请，在时装周主秀场PALAZZO DEL SENATO发布主题为“ VIAGGIO D’ARTE 艺术之旅”的2017春夏高级时装。现代意义上的时装设计从诞生的一刻起就注定与艺术结缘，ELLASSAY新季灵感正来源于与时装密不可分的艺术创作。',
      p6:'2016 年 11 月 2 日，中轴线侧，在历届帝王纷至崇礼的北京太庙正殿，ELLASSAY歌力思上演优雅20周年盛典时装秀。',
      p61:"作为中国现存规模最大的金丝楠木宫殿，太庙正殿中鎏金缠绕而成的画顶梁栋，珍贵稀缺的楠木大柱，为ELLASSAY塑就了有史以来最恢弘的秀场背景。而作为百年大殿的首秀，品牌的现代时装美学与古典皇家建筑的碰撞在秀场每一寸空间中拨动着现场嘉宾的神经，来自 ELLASSAY 新季系列的优雅长裙现代且时髦，腰、肩、腕的收放恰合中国女性的身型。",
      p7:'ELLASSAY歌力思应主办方邀请，在美国当地时间2014年9月7日，再次驻足纽约林肯中心时装周主会场SALON厅发布2015春夏新季时装。ELLASSAY新季发布带着“THE GRACEFUL ARTIST（优雅艺术家）”的主题向一代美国国宝，被誉为世纪舞蹈家的现代舞之母MARTHA GRAHAM女士致敬。作为本季灵感缪斯的MARTHA GRAHAM女士，其舞蹈强调动作的收与放，创造出力量和优雅并存的现代舞，与ELLASSAY张重视女性平衡之美的理念不谋而合。新季时装从这种平衡中取得灵感，将新古典元素与现代的时装风格融为一体，充分展示新时代女性的特点，更体现了纽约时装周无国界、自由创想的无限包容性。',
      p8:'美国当地时间2013年9月10日，ELLASSAY歌力思作为首个应邀参与纽约时装周的中国高级女装品牌，在纽约林肯中心时装周主会场STUDIO厅发布主题为“THE CITY LIGHT”的2014春夏高级时装。ELLASSAY以其一贯自信而不张扬的魅力，演绎独有的中国优雅，闪耀纽约城。',
      p81:'本季ELLASSAY发布的2014春夏系列，灵感来源于每个人内心都向往的美好圣地——爱琴海，身处美丽蔚蓝的海边感受时光逆行的独有恬静。偏好以纯洁无瑕的白色和浪漫柔和的淡蓝、冰蓝色等别具爱琴海风味的清新色彩，中和经典黑色及硬挺廓形的强势感。融合几近完美的剪载缝制，在无过多的装饰下，表现出知性沉静的摩登时尚感，延续ELLASSAY品牌精致优雅的美学理念。',
      p9:"经典迭新而来，优雅经久不衰。巴黎时间2月26日下午，ELLASSAY歌力思首次亮相巴黎时装周发布2024秋冬系列秀款「新经典 The Blooming Classics」。在“致敬经典”的语境下，新季系列延续优雅基调，探寻当代时尚灵感，在见证了历史兴衰的巴黎布隆尼亚尔宫内，充分回应对经典的尊重与革新。传奇超模Jessica Stam惊艳现身ELLASSAY歌力思秀场。早在14年前，Stam曾为歌力思拍摄过三季品牌大片。此次Stam再次与歌力思相约巴黎，是重聚，也是新的开始。",
      p10:'经典迭新而来，优雅经久不衰。巴黎时间2月26日下午，ELLASSAY歌力思首次亮相巴黎时装周发布2024秋冬系列秀款「新经典 The Blooming Classics」。在“致敬经典”的语境下，新季系列延续优雅基调，探寻当代时尚灵感，在见证了历史兴衰的巴黎布隆尼亚尔宫内，充分回应对经典的尊重与革新。传奇超模Jessica Stam惊艳现身ELLASSAY歌力思秀场。早在14年前，Stam曾为歌力思拍摄过三季品牌大片。此次Stam再次与歌力思相约巴黎，是重聚，也是新的开始。'
    },
    advertisement:{
      // a1:'率性优雅  风格无界',
      // a2:'2022秋冬大片',
      // a3:'ELLASSAY歌力思品牌代言人金晨全新演绎2022秋冬系列大片，用风格呈现本真，',
      // a4:'跨越多元场域与年龄界限，为女性的每一面赋予更多可能性。',
      // a5:'ELLASSAY歌力思2022秋冬系列，以时装作为女性发声的载体，',
      // a6:'打破刻板认知，在不断焕新风格中表达自我态度，展现「不被定义的美」。',
      a1:'新任品牌代言人 童瑶',
      a3:'ELLASSAY歌力思携手品牌代言人童瑶发布2023全新春季系列广告大片。',
      a4:'以从容姿态面对自我，聚焦坚定、勇敢，于自我家庭和事业中平衡自洽的当代女性。',
      a5:'镜头中的童瑶自带率性气质与松弛状态，以情绪感的镜头语言诠释女性在不同状态下的优雅从容，温柔沉静。',
      // b1:'HELLO ELLASSAY',
      // b2:'2022春夏大片',
      // b3:'ELLASSAY歌力思正式宣布演员金晨出任品牌代言人，共同以新生代美学与先锋精神逐步展开品牌的革新图景。',
      // b4:'2022年春夏新季大片，ELLASSAY歌力思携手品牌代言人金晨，在优雅的基调上不断探索与延展充满生命力的时装美学。好的时装并不只是建立一种完美的线条，更应当是一个宽阔明朗、舒适自由，让每一位被“HELLO ELLASSAY”问候过的访客都可以率性而为，追寻多元自我的演绎空间。',
      b1:'New Face of Classic ELLASSAY',
      b2:'2023秋季大片',
      b3:'ELLASSAY 歌力思2023秋季新品以“革新美学· 致敬经典”——New Face of Classic ELLASSAY 为主题，透过设计语言将经典魅力进行现代演绎。与品牌代言人童瑶一起，在经典中感知智性之美，开启全新的优雅时装旅程。',
      b4:'作为一名演员，镜头之内，童瑶通过不同角色的塑造，演绎了多元鲜明的角色，呈现出一个又一个经典的片段。镜头之外，童瑶演绎歌力思2023秋季新品系列，在尽数诠释镜头意境中，每一帧都展现率性与优雅的多面性。广告大片中，童瑶身着以经典电影角色与摩登都市为灵感的新季产品，组合明快色彩，孕育多元灵感，构筑歌力思的经典衣橱美学。',
      b21:'HELLO ELLASSAY',
      b22:'2022春夏大片',
      b23:'ELLASSAY歌力思2022春夏以“HELLO ELLASSAY”为主题，既是一句对当下的问候，也是品牌面向未来的自我展望。系列大片由Z世代超模@蒋瑞琪和品牌虚拟数字人@飒ELISA联袂演绎，采用新锐而富有张力的镜头语言碰撞CGI数字技术效果，形成虚实交错的超现实都市幻像。新季系列在坚持优雅的架构上，开辟更为率性自由的演绎空间，诠释女性在繁杂都市中敢于探寻真我，率性而为的状态。',
      c1:'TIME',
      c2:'2021秋冬大片',
      c3:'ELLASSAY歌力思2021数字大片，延续2021春夏的数字化概念，焕新品牌虚拟数字人@飒ELISA 形象，跨越时间边界，降临自然与科技共生的未知星际。以一贯的冒险和创新精神，步履不停地探索全新世界。',
      c4:'穿越虚拟与现实，此刻与未来，创造下一个无限可能。',
      d1:'界无止境',
      d2:'2021春夏大片',
      d3:'ELLASSAY2021春夏以一种全新的方式解码时尚。在艺术征程和日常轨道中与外界对话，共同探索未知与日常同在的美的疆域。而在这数字技术革新艺术表达的节点，虚拟数字人@飒ELISA，正是出现在合适的时空、开启奇遇般的转变。',
      e1:'CODE 2096',
      e2:'2020秋冬大片',
      e3:'2020秋冬以“CODE 2096”为主题概念，用3D影像创造出极具未来感的异星地貌和未来城市，虚拟与现实融合于一个全新的WONDERLAND。新季系列中蕴含了自然主义与复古精神等全然不然的崭新元素，并透过柔和与能量的色彩对比融合，引领对未来城市的丰富向往，让时空旅人在这个多维度的“离奇空间”里探寻潜藏在内心深处的幸福踪迹。',
      f1:'ONE TICKET',
      f2:'2024 春夏大片',
      f3:'ELLASSAY歌力思2024春夏，以ONE TICKET为主题，汲取法式优雅的时装哲学，以优雅入微之姿向外界传递一种无龄、无界、多元的女性魅力。品牌代言人童瑶以独特的风格演绎了ELLASSAY歌力思24春夏经典新品，打造多元的时尚风格，为品牌注入了崭新的“艺术与生命力"。',
      f4:'从都市出发，ELLASSAY LADY手握一张机票，即刻开启24春夏的时尚之旅，展开24春夏这份地图，自南法蔚蓝海岸起航，穿越花卉河流深处，唱响格拉斯小镇的假日旋律，与里维埃女士共同探索女性薪新历程。',
      g1:'The Blooming Classic • 新经典',
      g2:'2024秋冬大片',
      g3:'The Blooming Classic新经典，是时间更迭与展望间的共鸣。',
      g4:'ELLASSAY歌力思2024秋季系列，重溯思想交汇的人文主义时期，汲取经典色彩为灵感、融合现代设计手法，与古典人文精神跨越时间与风格促膝对话；从见证了历史兴衰的巴黎布隆尼亚尔宫开启探索，再次携手品牌代言人童瑶行走于古典韵致的上海历史博物馆，共同演绎经典新风貌。每一处细节、每一种色彩皆是经典与现代的对话，过去与未来在此刻交织，共同书写时尚新篇章。'
    },
    meta:{
      p1:"歌力思集团主品牌ELLASSAY 采用全CGI数字技术，于2020年推出虚拟数字人@飒ELISA。借由虚拟图像解码未来时尚，呈现数字化转型、可持续发展、多元表达、情感认同等精神内核的创想，运用科技为艺术设计赋能，步履不停地探索全新世界。",
      date1:"2020/10",
      s1:"启动@飒ELISA 人物制作",
      date2:'2020/11',
      s2:'完成人物形象设计',
      date3:"2020/12",
      s3:'完成3D建模和骨骼绑定，生成初代ELISA形象',
      date4:'2021/2',
      s4:'首次演绎ELLASSAY 歌力思2021春夏数字大片“界无止境”',
      date5:'2021/9',
      s5:'升级全CGI数字技术，焕新人物形象，演绎ELLASSAY 歌力思2021秋冬数字大片“TIME”',
      date6:'2022/1',
      s6:'首次与真人超模蒋瑞琪一同演绎ELLASSAY歌力思2022春夏大片“HELLO ELLASSAY”',
      date7:'2022/3',
      s7:'加入歌力思集团可持续发展部，成为集团首位数字员工，并担任集团「可持续时尚大使」。',
      p2:'ELLASSAY歌力思于上市7周年之际发布品牌首款限量数字藏品ELISA’S MULTI VERSE（ELISA多元宇宙）系列，通过品牌虚拟数字人@飒ELISA 展示ELLASSAY虚拟世界的一角。',
      p3:'ELLASSAY的虚拟世界是一个数字科技与艺术设计和谐交错的世界，有着赛博朋克式的未来想象，也有着无数次构建中浮现出的多元空间。整个系列如同探索宇宙秘境，在不断地自我回顾、自我重组中发现全新的身份和可能。',
      t1:'像素少女飒ELISA',
      p4:"ELLASSAY歌力思推出一系列品牌虚拟数字人@飒ELISA 像素风肖像，并打造系列表情包。以各种经典名人形象、跨次元游戏、科幻电影为题材，致敬经典，带来画风独到的创意体验。",
      p5:'像素作为最原始的图像表现方法，如今已成为一种独特的数字艺术创作风格。数字时尚已日渐成为ELLASSAY歌力思品牌内核中真实的组成部分，此次像素风的尝试也正是品牌一直以来对数字时尚的探索和创新。',
      t2:'2022春夏沉浸式球幕秀场',
      p6:'ELLASSAY WEEKEND 2022春夏发布会携手深圳时装周，打破物理局限，沉浸式地打造了一场全民参与的激光球幕秀场。',
      p7:'整个秀场采用俄罗斯艺术家团队研发的内投球展示技术，于全球首次应用于时装大秀，打破以往平面投影的局限，在不规则球幕上呈现360度的图像投射。以沉浸式的光影环绕，带来充满科技感的视觉盛宴。光影的运用无疑能减少资源的浪费，除此之外，在秀场打造中品牌还最大程度地减少着布景搭建以及一次性耗材的使用，对可持续时尚也是一种积极贡献。'
    },
    beast:{
      p1:'野兽数字科技（*YEAHSHOW DIGITAL）是深圳歌力思服饰股份有限公司旗下的全资子公司。是一家在消费升级时代，为高端品牌提供数字化运营服务的互联网公司。',
      p2:'*YEAHSHOW DIGITAL整合热点消费决策平台博主、明星和红人主播资源、 优质品牌和平台资源，重新定义销售市场和品牌营销，以大数据+内容快速 打通线上线下。为客户提供专业的电商直播、品牌代运营、品牌内容营销、明星、网红运营等价值链服务。',
      title1:'公司业务',
      t1:'品牌营销策划与执行',
      t2:'小红书品牌运营、博主合作、直播项目',
      t3:'大众点评达人种草&探店项目',
      t4:'品牌活动策划与执行',
      t5:'短视频内容策划与执行',
      title2:'合作品牌',
      title3:'合作平台'
    }
  }


// WEBPACK FOOTER //
// ./src/components/language/zh.js